import { Box, Card, CardContent, Divider, Modal } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { getDadosSirLojaOnline } from "../../services/motorService";
import MotorFilterModal from "./MotorFIlterModal";
import MotorHeader from "./MotorHeader";
import MotorList from "./MotorList";
import ItemDetails from "./ReservaModal";

const INITIAL_FILTERS = {
  numreserva: "",
  codreferencia: "",
  status_reserva: "",
  tipo_reserva: "",
  forma_pagamento: "",
  nome_promotor: "",
  status: "",
  motivo_cancelamento: "",
  observacao: "",
};

const FILTER_LABELS = {
  numreserva: "Nº Reserva",
  codreferencia: "Cód. Referência",
  status_reserva: "Status Reserva (PMS)",
  tipo_reserva: "Tipo de Reserva",
  forma_pagamento: "Forma de Pagamento",
  nome_promotor: "Promotor",
  status: "Status Motor",
  motivo_cancelamento: "Motivo Cancelamento",
  observacao: "Observação",
};

const includesText = (value, filter) => {
  if (!filter) return true;
  return String(value ?? "")
    .toLowerCase()
    .includes(String(filter).toLowerCase());
};

const MotorGrid = () => {
  const [dadosLojaOnline, setDadosSirLojaOnline] = useState([]);
  const [dadosFiltrados, setDadosFiltrados] = useState([]);
  const [dataInicio, setDataInicio] = useState();
  const [dataFim, setDataFim] = useState();
  const [tipoPeriodo, setTipoPeriodo] = useState("data_reserva");
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [params, setParams] = useState(INITIAL_FILTERS);

  const activeFilterChips = useMemo(
    () =>
      Object.entries(params)
        .filter(([, value]) => value !== "" && value !== null && value !== undefined)
        .map(([key, value]) => ({
          key,
          label: FILTER_LABELS[key] || key,
          value,
        })),
    [params]
  );

  const quantityFiltered = activeFilterChips.length;

  const resetFilters = () => {
    setParams({ ...INITIAL_FILTERS });
    setDadosFiltrados(dadosLojaOnline);
  };

  const changeFilter = (field, value) => {
    setParams((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const removeFilter = (field) => {
    setParams((prev) => ({
      ...prev,
      [field]: INITIAL_FILTERS[field],
    }));
  };

  const applyFilters = useCallback(() => {
    const filtrados = dadosLojaOnline.filter((item) => {
      return (
        includesText(item.numreserva, params.numreserva) &&
        includesText(item.codreferencia, params.codreferencia) &&
        includesText(item.status_reserva, params.status_reserva) &&
        includesText(item.tipo_reserva, params.tipo_reserva) &&
        includesText(item.forma_pagamento, params.forma_pagamento) &&
        includesText(item.nome_promotor, params.nome_promotor) &&
        includesText(item.status, params.status) &&
        includesText(item.motivo_cancelamento, params.motivo_cancelamento) &&
        includesText(item.observacao, params.observacao)
      );
    });

    setDadosFiltrados(filtrados);
  }, [dadosLojaOnline, params]);

  useEffect(() => {
    applyFilters();
  }, [applyFilters]);

  const handleConfirmFilters = () => {
    applyFilters();
    setFilterModalOpen(false);
  };

  const formatarData = (d) => {
    const dia = String(d.getDate()).padStart(2, "0");
    const mes = String(d.getMonth() + 1).padStart(2, "0");
    const ano = d.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  const handleFetchDados = useCallback(async (inicio, fim, periodo = tipoPeriodo) => {
    if (!inicio || !fim) {
      alert("Selecione data início e data fim.");
      return;
    }

    setLoading(true);
    try {
      const dados = await getDadosSirLojaOnline({
        dt_inicio: formatarData(inicio),
        dt_fim: formatarData(fim),
        tipo_periodo: periodo,
      });

      if (!Array.isArray(dados)) {
        const mensagem =
          dados?.error ||
          dados?.response?.data?.error ||
          dados?.message ||
          "Não foi possível carregar as reservas. Tente novamente.";
        console.error("Erro ao buscar dados do Motor:", dados);
        alert(mensagem);
        setDadosSirLojaOnline([]);
        setDadosFiltrados([]);
        return;
      }

      setDadosSirLojaOnline(dados);
      setDadosFiltrados(dados);
    } finally {
      setLoading(false);
    }
  }, [tipoPeriodo]);

  useEffect(() => {
    const inicio = new Date();
    inicio.setDate(1);
    const fim = new Date();

    setDataInicio(inicio);
    setDataFim(fim);

    handleFetchDados(inicio, fim, "data_reserva");
  }, []);

  const handleEditModal = (item) => {
    setSelectedItem(item);
    setDetailsModalOpen(true);
  };

  return (
    <Box sx={{ height: "80vh" }}>
      <MotorFilterModal
        open={filterModalOpen}
        onClose={() => setFilterModalOpen(false)}
        setIsFilter={handleConfirmFilters}
        changeFilter={changeFilter}
        params={params}
        resetFilters={resetFilters}
      />

      <Card>
        <Modal
          open={detailsModalOpen}
          onClose={() => setDetailsModalOpen(false)}
          aria-labelledby="modal-budget-details"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 1200,
              bgcolor: "background.paper",
              border: "2px solid #000",
              boxShadow: 24,
              p: 4,
              overflowY: "auto",
            }}
          >
            {selectedItem && (
              <ItemDetails
                item={selectedItem}
                onClose={() => setDetailsModalOpen(false)}
                handleEditRefetchData={() =>
                  handleFetchDados(dataInicio, dataFim, tipoPeriodo)
                }
              />
            )}
          </Box>
        </Modal>
      </Card>

      <Card sx={{ m: 3 }}>
        <CardContent container={true} spacing={3}>
          <MotorHeader
            loading={loading}
            setDataInicio={setDataInicio}
            setDataFim={setDataFim}
            dataInicio={dataInicio}
            dataFim={dataFim}
            tipoPeriodo={tipoPeriodo}
            setTipoPeriodo={setTipoPeriodo}
            handleFetchDados={handleFetchDados}
            openFilterModal={() => setFilterModalOpen(true)}
            quantityFiltered={quantityFiltered}
            resetFilters={resetFilters}
            activeFilterChips={activeFilterChips}
            onRemoveFilter={removeFilter}
            totalResultados={dadosFiltrados.length}
            totalCarregados={dadosLojaOnline.length}
          />
        </CardContent>
        <Divider />
        <CardContent container={true} spacing={3}>
          <MotorList
            dadosLojaOnline={dadosFiltrados}
            handleEditModal={handleEditModal}
            quantityFiltered={quantityFiltered}
          />
        </CardContent>
      </Card>
    </Box>
  );
};

export default MotorGrid;
